import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'

const getFeatured = graphql`
  query Featured {
    allContentfulProducts(filter: { featured: { eq: true } }) {
      nodes {
        mainImage {
          fluid(maxWidth: 500) {
            ...GatsbyContentfulFluid
          }
          title
        }
        id
        slug
        title
        category
      }
    }
  }
`

const Featured = () => {
  const data = useStaticQuery(getFeatured)

  return (
    <div className="container">
      <h2 className="title withLine">Featured Products</h2>
      <div className="titleLine"></div>
      <section className="ImageContainer">
        {data.allContentfulProducts.nodes.map(product => {
          return (
            <Link
              to={`/shop/${product.category}/${product.slug}`}
              className="ImageItem productitem"
              key={product.id}
            >
              <Img
                className="Image"
                alt={product.mainImage.title}
                fluid={product.mainImage.fluid}
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                }}
                objectFit="cover"
              />
              <h3>{product.title}</h3>
            </Link>
          )
        })}
      </section>
    </div>
  )
}

export default Featured
